import { formatDateWithDayjs } from "../../../../utils/utils";
export const COLUMNS = [
  {
    Header: "Invoice Number",
    Footer: "Invoice Number",
    accessor: "invoiceNumber"
  },
  {
    Header: "Customer",
    Footer: "Customer",
    accessor: "debatorName"
  },
  {
    Header: "Invoice Total",
    Footer: "Invoice Total",
    accessor: "totalAmount",
    Cell: ({ value }) => {
      const formattedValue =
        value !== undefined && value !== null && value !== ""
          ? value.toFixed(2)
          : "0.00";
      return `$${formattedValue}`;
    }
  },
  {
    Header: "Due Date",
    Footer: "Due Date",
    accessor: "dueDate",
    Cell: ({ value }) => {
      if (value) {
        return formatDateWithDayjs(value, "DD-MMM-YYYY");
      } else {
        return "";
      }
    }
  }
];
